import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';

export default () => {
  const location = useLocation();
  return parse(location.search);
};
